import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { Filter, Main } from 'Containers/';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { GA_CASH_INCOME_FORM_NAME } from 'Common/FormEnum';
import { GACashIncomeFieldEnum as Fields } from 'Common/FieldEnum';
import { withReportSubscription } from 'State/report/withReportSubscription';
import * as CommonStateSelectors from 'State/selectors';

import { GACashIncomeForm } from './components/GACashIncomeForm';

class GACashIncomeContainer extends Component {
  getMainProps = () => {
    const { reportFetching } = this.props;
    return {
      toolbox: {
        formName: GA_CASH_INCOME_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: reportFetching,
          disabled: reportFetching,
        },
        shown: true,
      },
    };
  };

  handleSubmit = (values) => {
    const { getReport } = this.props;
    getReport('reports/GACashIncome', values);
  };

  render() {
    const { reportFetching } = this.props;
    return (
      <Fragment>
        <Filter title={'GA Cash Income'} />
        <Main {...this.getMainProps()}>
          <GACashIncomeForm
            loading={reportFetching}
            onSubmit={this.handleSubmit}
            initialValues={{
              [Fields.ToDate]: defaultDateFormat(moment()),
              [Fields.FromDate]: defaultDateFormat(moment()),
            }}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    fiscalYears: CommonStateSelectors.getFiscalYears(state),
  };
};

GACashIncomeContainer = withReportSubscription(GACashIncomeContainer);

export const GACashIncome = connect(mapStateToProps)(GACashIncomeContainer);



// WEBPACK FOOTER //
// ./src/pages/gacashincome/GACashIncome.js